import { TFunction } from 'i18next';
import * as Yup from 'yup';
export const validationSchema = (t: TFunction) =>
  Yup.object({
    productName: Yup.string()
      .max(255, t('valid_err_max', { max: 255 }))
      .required(t('valid_err_product_name')),
    productCode: Yup.string().when('pageConfig.custom_item_code', {
      is: true,
      then: (schema) =>
        schema
          .max(50, t('valid_err_max', { max: 50 }))
          .required(t('valid_err_product_code')),
      otherwise: (schema) => schema.optional(),
    }),
    pageConfig: Yup.object({
      custom_item_code: Yup.boolean(),
    }),

    barcode: Yup.string()
      .nullable()
      .test(
        'max-if-not-null',
        t('valid_err_max', { max: 255 }),
        function (value) {
          if (value === null || value === undefined) return true;
          return value.length <= 255;
        }
      ),
    // barcode: Yup.string().nullable(),
    category: Yup.string().required(t('valid_err_category')),
    supplier: Yup.string().nullable(),
    // productDetails: Yup.string().nullable(),
    productDetails: Yup.string()
      .nullable()
      .test(
        'max-if-not-null',
        t('valid_err_max', { max: 255 }),
        function (value) {
          if (value === null || value === undefined) return true;
          return value.length <= 255;
        }
      ),

    cost_price: Yup.object().shape({
      value: Yup.string()
        .typeError(t('valid_err_number'))
        .required(t('valid_err_price')),
      apply_all: Yup.number().oneOf([0, 1], t('valid_err_apply_all')),
    }),
    unit_price: Yup.object().shape({
      value: Yup.string()
        .typeError(t('valid_err_number'))
        .required(t('valid_err_price')),
      apply_all: Yup.number().oneOf([0, 1], t('valid_err_apply_all')),
    }),
    unit_price1: Yup.object().shape({
      value: Yup.string().nullable(),
      apply_all: Yup.number().oneOf([0, 1], t('valid_err_apply_all')),
    }),
    unit_price2: Yup.object().shape({
      value: Yup.string().nullable(),
      apply_all: Yup.number().oneOf([0, 1], t('valid_err_apply_all')),
    }),
    unit_price3: Yup.object().shape({
      value: Yup.string().nullable(),
      apply_all: Yup.number().oneOf([0, 1], t('valid_err_apply_all')),
    }),
    unit_price4: Yup.object().shape({
      value: Yup.string().nullable(),
      apply_all: Yup.number().oneOf([0, 1], t('valid_err_apply_all')),
    }),

    vat: Yup.number().nullable(),
    product_stock_type: Yup.string().nullable(),
    inventory_type: Yup.string()
      // .required(t('valid_err_required'))
      .notOneOf(['0'], t('valid_err_required')),

    composites: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required(t('valid_err_required')),
          item_id_number: Yup.number().required(t('valid_err_required')),
          quantity: Yup.number()
            .typeError(t('valid_err_3_decimals'))
            .test(
              'is-decimal',
              t('valid_err_3_decimals'),
              (value) =>
                value === undefined ||
                value === null ||
                /^\d+(\.\d{1,3})?$/.test(value.toString())
            )
            .min(0.01, t('valid_err_min_value'))
            .required(t('valid_err_required')),
        })
      )

      .when('inventory_type', {
        is: '2',
        then: (schema) =>
          schema
            .min(1, t('valid_err_add_required'))
            .required(t('valid_err_add_required')),
        otherwise: (schema) => schema.nullable(),
      }),

    productOptions: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required(),
        name: Yup.string().required(),
        selected: Yup.boolean().required(),
        options: Yup.lazy((options, ctx) => {
          const parent = ctx?.parent as any;
          const isSelected = parent?.selected;

          if (isSelected) {
            return Yup.array()
              .of(
                Yup.object().shape({
                  value: Yup.number()
                    .typeError(t('valid_err_3_decimals'))
                    .test(
                      'is-decimal',
                      t('valid_err_3_decimals'),
                      (value) =>
                        value === undefined ||
                        value === null ||
                        /^\d+(\.\d{1,3})?$/.test(value.toString())
                    )
                    .min(0, t('valid_err_min_zero'))
                    .required(t('valid_err_required')),
                })
              )
              .min(1, t('valid_err_required'))
              .required(t('valid_err_required'));
          }

          return Yup.array()
            .of(
              Yup.object().shape({
                value: Yup.number().notRequired().nullable(),
              })
            )
            .notRequired()
            .nullable();
        }),
      })
    ),

    quantity_notify: Yup.number().nullable(),
  });
export type ProductValidationSchemaType = ReturnType<typeof validationSchema>;
